import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        loadComponent: () => import('./list/list.component').then(m => m.NewsListComponent)
      },
      {
        path: 'news/preview/:id',
        loadComponent: () => import('./preview/preview.component').then(m => m.PreviewComponent)
      },
      {
        path: 'news',
        loadComponent: () => import('./list/list.component').then(m => m.NewsListComponent)
      },
      {
        path: 'news/:id',
        loadComponent: () => import('./detail/detail.component').then(m => m.NewsDetailComponent)
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  declarations: []
})
export class NewsModule {}
